export const maxCaTeamSize = 5;
